module.exports = __webpack_public_path__ + "static/img/Bachelor_010559.7e90edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010559.jpg
// module id = 189
// module chunks = 0